// reducers/friendsReducer.ts
import { SET_FRIENDS } from '../actions';
import Action from '../actions';
import { Friend } from '../type';

const initialState: Friend[] = [];

const friendsReducer = (state = initialState, action: Action): Friend[] => {
  switch (action.type) {
    case SET_FRIENDS:
      return [...(action.payload as Friend[])];
    default:
      return state;
  }
};

export default friendsReducer;
